import './resume.css'
import ImgAnyc from './img/anyc.png';
import ImgOpen from './img/open.jpg';
import ImgNatech from './img/nateck.png';
import ImgMelting from './img/meltinggraph.png';
import ImgHetic from './img/hetic.png';
import ImgRncp from './img/rncp.png';
import ImgCerco from './img/cerco.png';
import ImgCoursera from './img/coursera.png';
import ImgUdemy from './img/udemy.png';
import ImgOpenclas from './img/openclassroom.png';
import {
    Container, Row, Col, Button
} from 'reactstrap';

const Resume = () => {
    return (
        <Container className='resume-container pb-5' id='resume'>
            <h3 className='title'>ILS M'ONT FAIT CONFIANCE</h3>
            <Row className="align-items-center justify-content-center logo-row">
                
                <Col xs={4} sm={3} md={2} className="logo-item">
                    <img width="120px" src={ImgAnyc} alt="Anycommerce" />
                </Col>
                <Col xs={4} sm={3} md={2} className="logo-item">
                    <img width="80px" src={ImgMelting} alt="melting graph" />
                </Col>
                <Col xs={4} sm={3} md={2} className="logo-item">
                    <img width="80px" src={ImgNatech} alt="natech" />
                </Col>
                <Col xs={4} sm={3} md={2} className="logo-item">
                    <img width="100px" src={ImgOpen} alt="open" />
                </Col>
                
            </Row>
            <h3 className='title'>MON PARCOURS</h3>
            <Row className="align-items-center justify-content-center logo-row">
                
                <Col xs={4} sm={3} md={2} className="logo-item">
                    <img width="50px" src={ImgHetic} alt="hetic" />
                </Col>
                <Col xs={4} sm={3} md={2} className="logo-item">
                    <img width="120px" src={ImgRncp} alt="rncp" />
                </Col>
                <Col xs={4} sm={3} md={2} className="logo-item">
                    <img width="80px" src={ImgCerco} alt="cerco" />
                </Col>
                <Col xs={4} sm={3} md={2} className="logo-item">
                    <img width="100px" src={ImgCoursera} alt="coursera" />
                </Col>
                <Col xs={4} sm={3} md={2} className="logo-item">
                    <img width="80px" src={ImgUdemy} alt="udemy"/>
                </Col>
                <Col xs={4} sm={3} md={2} className="logo-item">
                    <img width="50px" src={ImgOpenclas} alt="openclassroom" />
                </Col>
                
            </Row>
        </Container>
    );
}

export default Resume;